// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"165055b3","589":"37c9c1e3"}[chunkId] + ".chunk.js";
};